module.exports = __webpack_public_path__ + "img/emparejamiento.d2ff732f.svg";